var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalculator(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "46px",
    viewBox: "0 0 35 46",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "calculator") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Movil",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ecommerce",
    transform: "translate(-783.000000, -1166.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy-2",
    transform: "translate(764.000000, 1152.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calculator",
    transform: "translate(20.404412, 15.330882)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.7573529,41.7774936 C32.7573529,42.8219309 31.8360524,43.6764706 30.7100184,43.6764706 L2.04733456,43.6764706 C0.921300551,43.6764706 0,42.8219309 0,41.7774936 L0,1.89897698 C0,0.854539642 0.921300551,0 2.04733456,0 L30.7100184,0 C31.8360524,0 32.7573529,0.854539642 32.7573529,1.89897698 L32.7573529,41.7774936 L32.7573529,41.7774936 Z",
    id: "Stroke-5020",
    stroke: "#004AD1",
    strokeWidth: 0.913846154,
    fill: "#004AD1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Stroke-5021",
    fill: "#FFFFFF",
    points: "28.7867647 13.6488971 3.97058824 13.6488971 3.97058824 3.63970588 28.7867647 3.63970588"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8161765,7.27941176 L24.8161765,10.0091912",
    id: "Stroke-5022",
    stroke: "#004AD1",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94852941,20.9283088 L9.92647059,20.9283088",
    id: "Stroke-5023",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9117647,20.9283088 L14.8897059,20.9283088",
    id: "Stroke-5024",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8676471,20.9283088 L20.8455882,20.9283088",
    id: "Stroke-5025",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8161765,20.9283088 L27.7941176,20.9283088",
    id: "Stroke-5026",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94852941,26.3878676 L9.92647059,26.3878676",
    id: "Stroke-5027",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9117647,26.3878676 L14.8897059,26.3878676",
    id: "Stroke-5028",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8676471,26.3878676 L20.8455882,26.3878676",
    id: "Stroke-5029",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8161765,26.3878676 L27.7941176,26.3878676",
    id: "Stroke-5030",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94852941,32.7573529 L9.92647059,32.7573529",
    id: "Stroke-5031",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9117647,32.7573529 L14.8897059,32.7573529",
    id: "Stroke-5032",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8676471,32.7573529 L20.8455882,32.7573529",
    id: "Stroke-5033",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8161765,32.7573529 L27.7941176,32.7573529",
    id: "Stroke-5034",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.94852941,37.3069853 L9.92647059,37.3069853",
    id: "Stroke-5035",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9117647,37.3069853 L14.8897059,37.3069853",
    id: "Stroke-5036",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8676471,37.3069853 L25.8088235,37.3069853",
    id: "Stroke-5037",
    stroke: "#FFFFFF",
    strokeWidth: 0.913846154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculator);
export default __webpack_public_path__ + "static/media/calculator.a660218a2cfcdebc935a09b4286dfab6.svg";
export { ForwardRef as ReactComponent };